import { useMemo } from "react";
import { useFormContext } from "react-hook-form";
import { DispatcherOrderEntryAdditionalField } from "@api/graphql/generated/generated-types";
import { isCallerRequired } from "@src/common/lib/requiredAdditionalFieldUtils";

export function useIsCallerNameRequired(
  dispatcherOrderEntryAdditionalFields?: DispatcherOrderEntryAdditionalField[]
): boolean {
  const { watch } = useFormContext();
  const callerPhone = watch("callerPhone");

  return useMemo(
    () => isCallerRequired(dispatcherOrderEntryAdditionalFields) || !!callerPhone,
    [dispatcherOrderEntryAdditionalFields, callerPhone]
  );
}
